// removed by extract-text-webpack-plugin
module.exports = {"overlay":"Overlay__overlay___3VLG6","opacity":"Overlay__opacity___h115x","onTop":"Overlay__onTop___2jq7N","container":"Overlay__container___3Brbg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Overlay/Overlay.css
// module id = 876
// module chunks = 0